// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"ElementContextMenu_tooltip__3l8uJ","visible":"ElementContextMenu_visible__2Nqnv"};